export namespace PaymentEvent {
  export interface EventDetails extends Event {
    detail?: PaymentResult;
  }

  export enum PaymentResultCode {
    SUCCEEDED = 'SUCCEEDED',
    FAILED = 'FAILED',
    PENDING = 'PENDING',
  }

  export interface PaymentResult {
    resultCode: PaymentResultCode;
    resultDetails?: {
      message: string;
      errorCode?: string;
    };
  }
}

export namespace PaymentServiceBusNS {
  export interface Message {
    body: PaymentNotification;
  }

  export interface PaymentNotification {
    paymentReference: string;
    eventCode: EventCode;
    tokenReference?: string;
    message?: string;
    channelReference?: string;
  }

  export type EventCode =
    | 'AUTHORISATION_SUCCEEDED'
    | 'AUTHORISATION_FAILED'
    | 'REFUND_SUCCEEDED'
    | 'REFUND_FAILED'
    | 'REFUND_REVERSED';
}
